module.exports = __webpack_public_path__ + "img/remoteExpert.a564ad2.svg";